export default __webpack_public_path__ + "static/media/smile.0dcadbec.svg";